import React, { useState } from 'react';

const TriggerBuilder = ({ triggers, setTriggers }) => {
    const [isAdding, setIsAdding] = useState(false);
    const [newTrigger, setNewTrigger] = useState({
        type: 'text',
        match: 'contains',
        pattern: '',
        case_insensitive: true,
        source: ''
    });

    const handleAddStart = () => {
        setIsAdding(true);
        setNewTrigger({
            type: 'text',
            match: 'contains',
            pattern: '',
            case_insensitive: true,
            source: ''
        });
    };

    const handleSaveTrigger = () => {
        if (!newTrigger.pattern) {
            alert("Pattern is required");
            return;
        }
        if (newTrigger.type === 'reply' && !newTrigger.source) {
            alert("Source is required for reply triggers");
            return;
        }

        setTriggers([...triggers, { ...newTrigger }]);
        setIsAdding(false);
    };

    const handleRemoveTrigger = (index) => {
        const newTriggers = [...triggers];
        newTriggers.splice(index, 1);
        setTriggers(newTriggers);
    };

    return (
        <div style={{ padding: '10px' }}>
            <h3 className="wf-section-title">Triggers</h3>

            {triggers.map((trigger, idx) => (
                <div key={idx} className="wf-trigger-item">
                    <div className="wf-remove-btn" onClick={() => handleRemoveTrigger(idx)}>×</div>
                    <div><strong>Type:</strong> {trigger.type}</div>
                    <div><strong>Match:</strong> {trigger.match}</div>
                    <div><strong>Pattern:</strong> {trigger.pattern}</div>
                    {trigger.type === 'reply' && <div><strong>Source:</strong> {trigger.source}</div>}
                </div>
            ))}

            {isAdding ? (
                <div className="wf-trigger-item" style={{ background: '#334155' }}>
                    <label className="wf-label">Type</label>
                    <select
                        className="wf-input"
                        value={newTrigger.type}
                        onChange={e => setNewTrigger({ ...newTrigger, type: e.target.value })}
                    >
                        <option value="text">Text</option>
                        <option value="reply">Reply</option>
                    </select>

                    <label className="wf-label">Match</label>
                    <select
                        className="wf-input"
                        value={newTrigger.match}
                        onChange={e => setNewTrigger({ ...newTrigger, match: e.target.value })}
                    >
                        <option value="contains">Contains</option>
                        <option value="equals">Equals</option>
                    </select>

                    <label className="wf-label">Pattern</label>
                    <input
                        className="wf-input"
                        value={newTrigger.pattern}
                        onChange={e => setNewTrigger({ ...newTrigger, pattern: e.target.value })}
                        placeholder="e.g. hello"
                    />

                    {newTrigger.type === 'reply' && (
                        <>
                            <label className="wf-label">Source</label>
                            <select
                                className="wf-input"
                                value={newTrigger.source}
                                onChange={e => setNewTrigger({ ...newTrigger, source: e.target.value })}
                            >
                                <option value="">Select Source</option>
                                <option value="button">Button</option>
                            </select>
                        </>
                    )}

                    <label className="wf-label" style={{ display: 'flex', gap: '5px' }}>
                        <input
                            type="checkbox"
                            checked={newTrigger.case_insensitive}
                            onChange={e => setNewTrigger({ ...newTrigger, case_insensitive: e.target.checked })}
                        />
                        Case Insensitive
                    </label>

                    <div style={{ display: 'flex', gap: '5px', marginTop: '10px' }}>
                        <button className="wf-btn wf-btn-primary" onClick={handleSaveTrigger}>Add</button>
                        <button className="wf-btn" style={{ background: '#475569' }} onClick={() => setIsAdding(false)}>Cancel</button>
                    </div>
                </div>
            ) : (
                <button
                    className="wf-btn"
                    style={{ width: '100%', background: '#334155', border: '1px dashed #475569' }}
                    onClick={handleAddStart}
                >
                    + Add Trigger
                </button>
            )}
        </div>
    );
};

export default TriggerBuilder;
